/** @jsx jsx */
import { css, Theme } from "@emotion/react";
import { ThemedCssCreator } from "../../config/emotion";

export const roundCornersShadowBorder = () => css`
  border-radius: 5px;
  box-shadow: 0px 2px 3px #e7e8ec;
  background-color: white;
`;

export const primaryTextColorCss: ThemedCssCreator = ({ colors }) => css`
  color: ${colors.primaryColor};
`;
export const secondaryTextColorCss: ThemedCssCreator = ({ colors }) => css`
  color: ${colors.secondaryColor};
`;

export const primaryBgColorCss: ThemedCssCreator = ({ colors }) => css`
  background-color: ${colors.primaryColor};
`;
export const secondaryBgColorCss: ThemedCssCreator = ({ colors }) => css`
  background-color: ${colors.secondaryColor};
`;
export const setPrimaryAsColor = (theme: Theme) => css`
  color: ${theme.colors.primaryColor};
`;
